import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { services, interiorImage } from "../mock";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();
  return (
    <main className="pt-[72px]">
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pt-16 md:pt-24">
        <span data-testid="services-eyebrow" className="inline-block px-4 py-1.5 rounded-full border border-black/25 text-[10px] font-medium uppercase tracking-[0.16em] mb-8">
          {t("servicesPage.eyebrow")}
        </span>
        <h1 data-testid="services-heading" className="font-display font-bold text-[2.5rem] sm:text-6xl md:text-7xl lg:text-8xl xl:text-[9rem] leading-[0.88] tracking-tight mb-8">
          {t("servicesPage.title")}
        </h1>
        <p className="font-display text-[clamp(1.3rem,3.4vw,2.6rem)] leading-[1.15] tracking-tight max-w-3xl text-balance">
          <span data-testid="services-intro-lead">{t("servicesPage.lead")} </span>
          <span data-testid="services-intro-detail" className="text-[#0e0e10]/35">{t("servicesPage.muted")}</span>
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
          {services.map((s, i) => (
            <div key={s.no} style={{ "--reveal-delay": `${(i % 3) * 90}ms` }} className="reveal-on-scroll min-w-0 group border-t border-black/15 py-8 hover:border-black/40 transition-colors">
              <div className="flex items-center justify-between mb-6">
                <span data-testid={`service-number-${s.no}`} className="text-[#0057FF] font-display text-sm">{s.no}</span>
                <ArrowUpRight size={20} className="hover-arrow text-[#0e0e10]/40 group-hover:text-[#0e0e10]" />
              </div>
              <h3 data-testid={`service-title-${s.no}`} className="font-display text-2xl tracking-tight mb-3 break-words [hyphens:auto]">{t(`services.${i}.title`)}</h3>
              <p data-testid={`service-description-${s.no}`} className="text-[13px] text-[#0e0e10]/55 leading-relaxed">{t(`services.${i}.desc`)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Image band */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-20">
        <div data-testid="services-contact-band" className="reveal-on-scroll img-zoom-wrap relative w-full max-w-full min-w-0 overflow-hidden rounded-sm aspect-[4/5] sm:aspect-[16/9] lg:aspect-[16/7] min-h-[420px]">
          <img src={interiorImage} data-testid="services-image" alt={t("common.interior")} className="img-zoom absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/30" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p data-testid="services-contact-eyebrow" className="text-white/80 text-[11px] uppercase tracking-[0.18em] mb-4">{t("servicesPage.ctaLabel")}</p>
            <h2 data-testid="services-contact-heading" className="text-white font-display font-bold text-[clamp(1.8rem,5vw,3.5rem)] leading-tight tracking-tight mb-8">
              {t("servicesPage.ctaTitle")}
            </h2>
            <Link to="/kontakt" data-testid="services-contact-link" className="group inline-flex max-w-full items-center justify-center gap-3 px-5 sm:px-8 py-3.5 rounded-full bg-white text-[#0e0e10] text-xs sm:text-sm font-medium uppercase tracking-[0.12em] hover:bg-[#0057FF] hover:text-white transition-colors duration-300">
              {t("common.requestQuote")} <ArrowUpRight size={18} className="hover-arrow shrink-0" />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
